module.exports = __webpack_public_path__ + "static/img/gggggg_14.cb3382f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_14.png
// module id = q7MZ
// module chunks = 1